import { updateObject } from '../../shared/utils/utils';
import * as actionTypes from './actionTypes';

const initialState = {
    dashboard: null,
    consumptionPolicy: null,
    loading: false,
    selectedCompanyId: null,
    auditLog: [],
    auditLogLoading: false,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_DASHBOARD_SUCCESS:
            return updateObject(state, { dashboard: action.payload });
        case actionTypes.SET_DASHBOARD_LOADING:
            return updateObject(state, { loading: action.payload });
        case actionTypes.SET_SELECTED_COMPANY_ID:
            return updateObject(state, { selectedCompanyId: action.payload });
        case actionTypes.FETCH_CONSUMPTION_POLICY_SUCCESS:
            return updateObject(state, { consumptionPolicy: action.payload });
        case actionTypes.FETCH_AUDIT_LOG_SUCCESS:
            return updateObject(state, { auditLog: action.payload });
        case actionTypes.SET_AUDIT_LOG_LOADING:
            return updateObject(state, { auditLogLoading: action.payload });
        default:
            return state;
    }
};
